import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CATEGORY_FEES = {
  "U17 Boys": 4000,
  "U15 Boys": 3000,
  "U13 Boys": 2000,
  Girls: 1000,
};

function Payment() {
  const location = useLocation();
  const navigate = useNavigate();
  const team = location.state?.team;

  const [teamName, setTeamName] = useState(team?.teamName || "");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // null | 'waiting'
  const [error, setError] = useState("");

  if (!team) {
    return (
      <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
        <p className="text-lg">No team data found. Please log in first.</p>
      </div>
    );
  }

  const fee = CATEGORY_FEES[team.category] || 0;

  const pollStatus = (checkoutId) => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/payments/status/${checkoutId}`,
        );
        const data = await res.json();
        if (data.paymentStatus === "PAID") {
          clearInterval(interval);
          clearTimeout(timeout);
          navigate("/dashboard", { state: { team: data.team } });
        } else if (data.paymentStatus === "FAILED") {
          clearInterval(interval);
          clearTimeout(timeout);
          setStatus(null);
          setError("Payment failed or was cancelled. Please try again.");
        }
      } catch (err) {
        // keep polling silently; a network hiccup shouldn't stop the flow
      }
    }, 3000);

    // Stop polling after 2 minutes to avoid an endless loop
    const timeout = setTimeout(() => {
      clearInterval(interval);
      setStatus(null);
      setError(
        "We have not received confirmation yet. If money was deducted, wait a minute and check your teams page. Otherwise try again.",
      );
    }, 120000);
  };

  const handlePay = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/payments/initiate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ team, teamName, phone }),
        },
      );
      const data = await res.json();

      if (res.ok) {
        // DEMO MODE: backend already marked the team as PAID, skip the prompt
        if (data.demo) {
          navigate("/dashboard", { state: { team: data.team } });
          return;
        }
        setStatus("waiting");
        pollStatus(data.checkout_id);
      } else {
        setError(data.error || "Payment could not be started");
      }
    } catch (err) {
      setError("Could not reach server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-5 w-full max-w-sm space-y-3 text-center">
        <h1 className="text-xl font-bold text-brand-red">
          Team Registration Fee
        </h1>
        <p className="text-sm text-gray-600">{team.category}</p>
        <p className="text-3xl font-bold text-brand-dark">KES {fee}</p>

        {status === "waiting" ? (
          <p className="text-sm text-gray-600">
            Check your phone and enter your M-PESA PIN to complete payment.
            This page will update automatically once payment is confirmed.
          </p>
        ) : (
          <form onSubmit={handlePay} className="space-y-3">
            <input
              placeholder="Team Name"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
              className="w-full border rounded-lg p-2.5 text-base"
              required
            />
            <input
              placeholder="M-PESA Phone Number (e.g. 0712345678)"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full border rounded-lg p-2.5 text-base"
              required
            />
            {error && <p className="text-red-600 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-gold text-brand-dark font-bold text-base py-2.5 rounded-lg hover:opacity-90 disabled:opacity-50"
            >
              {loading ? "Sending prompt..." : "Pay Now"}
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="w-full text-sm text-gray-500 underline"
            >
              Back
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Payment;